'use client';

import { Button } from '@pickleballinc/ui/components/ui/button';
import clsx from 'clsx';
import dayjs from 'dayjs';
import Link from 'next/link';
import { useState } from 'react';

import { WithdrawPlayerModal } from '@/components/molecules/modals/WithdrawPlayerModal';
import { publicEnv } from '@/lib/env';
import { useOrganizationStore } from '@/store/organization-store';

interface DetailsRegistrationButtonProps {
	isRegistrationOpen?: boolean | null;
	registrationEndDate?: Date | null;
	isUserPartOfLeague?: boolean | null;
	className?: string;
	useRegularStyling?: boolean;
}

export const DetailsRegistrationButton = ({
	isRegistrationOpen,
	registrationEndDate,
	isUserPartOfLeague,
	className,
	useRegularStyling
}: DetailsRegistrationButtonProps) => {
	const organizationStore = useOrganizationStore();
	const [showModal, setShowModal] = useState(false);

	const handleRegistrationModal = () => {
		setShowModal((prev) => !prev);
	};

	return (
		<>
			{showModal ? <WithdrawPlayerModal onClose={handleRegistrationModal} /> : null}

			<div className={`flex flex-col items-center xl:w-full ${className ?? ''}`}>
				{isRegistrationOpen && !isUserPartOfLeague ? (
					<div className="w-full">
						<Link
							href={`${publicEnv.NEXT_PUBLIC_PTL_CHECKOUT_URL}/team-league/${organizationStore.organizationUuid}/${organizationStore.teamLeagueUuid}`}
						>
							<Button className="w-full px-[26px] py-3 leading-6 text-white">Register now</Button>
						</Link>
						{registrationEndDate ? (
							<p className="hidden text-[10px] pt-2 items-start text-left max-w-[150px]">
								Registration ends {dayjs(registrationEndDate).format('MMM D YYYY h:mm A')}
							</p>
						) : null}
					</div>
				) : (
					<>
						{isUserPartOfLeague ? (
							<Button
								onClick={handleRegistrationModal}
								className={clsx('w-full font-semibold leading-6 w-full md:w-52', {
									'text-xs !h-8': useRegularStyling,
									'!h-9': !useRegularStyling
								})}
							>
								Withdraw
							</Button>
						) : null}
					</>
				)}
			</div>
		</>
	);
};
